import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputItem from '../../../../component/inputItem';
import { MainButton } from '../../../../component/button';
import { useMobile } from '../../../../hook/usePlatform';
import { lineColor } from '../../../../util/colors';
import useAuth from '../../../../hook/useAuth';

const LoginInput:React.FC = () => {
  const { loginUser } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;
  const onLogin = async () => {
    try {
      await loginUser(email, password);
    } catch (e) {
      setError('이메일 또는 비밀번호를 확인해주세요.');
    }
  };
  useEffect(() => {
    setError(null);
  }, [email, password]);
  return (
    <div
      style={{
        borderTop: border,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: isMobile ? 0 : 200,
      }}
    >
      <div
        style={{
          width: isMobile ? '90%' : '30%',
          display: 'flex',
          flexDirection: 'column',
          gap: 30,
          paddingBlock: isMobile ? 32 : 54,
        }}
      >
        <InputItem
          title="이메일"
          placeholder="이메일을 입력해주세요."
          value={email}
          setValue={setEmail}
          required
        />
        <InputItem
          title="비밀번호"
          placeholder="비밀번호를 입력해주세요."
          type="password"
          value={password}
          setValue={setPassword}
          errorText={error ?? ''}
          isError={error !== null}
          required
        />
        <MainButton
          text="로그인"
          onPress={onLogin}
          style={{ width: '100%' }}
          disable={email.length === 0 || password.length === 0}
        />
      </div>
    </div>
  );
};

export default LoginInput;
